import './ZeroForm'

customElements.define('zero-form-dialog', class extends HTMLElement {
    constructor() {
        super().attachShadow({mode:'open'}).innerHTML = this.render()
        this.listen()
    }

    close() {
        this.shadowRoot.querySelector('dialog').close()
    }

    showModal() {
        this.shadowRoot.querySelector('dialog').showModal()
    }

    listen() {
        if(!this.hasAttribute('data-listen')) return

        if(window.location.hash === `#/${this.dataset.listen}`) {
            this.showModal()
        }
    }

    render() {
        return `
            <style>
                .trigger {
                    all: unset;
                    font-family: var(--font);
                    color: var(--color-1);
                    cursor: pointer;
                    display: block;
                    font-weight: 600;
                    margin-block: 2em;
                    text-decoration: underline;
                    width: fit-content;

                    &:hover {
                        color: var(--color-4-dk);
                    }

                    &:focus-visible {
                        outline: 0.2rem solid var(--color-3);
                        outline-offset: 0.3rem;
                    }
                }

                dialog[open] {
                    animation: in 500ms linear(0, 0.03 1.5%, 0.121 3.2%, 0.851 13%, 0.99 16.4%, 1.063 20.2%, 1.076 22.3%, 1.075 24.8%, 1.013 35.9%, 0.995 43.4%, 1);
                    border: none;
                    border-radius: var(--radius-md);
                    box-shadow: 0 1rem 10rem hsl(0 0% 0% / 0.3);
                    color: var(--color-1);
                    inset: 0;
                    outline: none;
                    padding: var(--gap-sm);
                    padding-block-start: var(--gap-md);
                    position: fixed;
                    width: min(50rem, 70vw);
                }

                .close {
                    --size: 3.4rem;

                    all: unset;
                    background: transparent;
                    border: 0.2rem solid var(--neutral-2);
                    border-radius: var(--size);
                    box-sizing: border-box;
                    cursor: pointer;
                    height: var(--size);
                    inset: 2rem 2rem auto auto;
                    margin-left: auto;
                    padding: 0;
                    position: absolute;
                    transform: rotate(45deg);
                    transition: all 300ms ease;
                    width: var(--size);
                }

                .close::before, .close::after {
                    background-color: var(--neutral-3);
                    border-radius: 0.3rem;
                    content: '';
                    height: 0.3rem;
                    left: 50%;
                    position: absolute;
                    top: 50%;
                    transform: scale(1) translate(-50%, -50%);
                    transition: all 300ms ease;
                    width: 1.6rem;
                }

                .close::after {
                    transform: translate(-50%, -50%) rotate(90deg);
                }

                .close:hover {
                    background-color: var(--color-2);
                    border-color: var(--color-2);
                }

                .close:focus-visible {
                    outline: 0.2rem solid var(--color-2);
                    outline-offset: 0.3rem;
                }

                .close:hover::before, 
                .close:hover::after {
                    background-color: var(--content);
                }

                @keyframes in {
                    0% {
                        opacity: 0;
                        scale: 0.7;
                    }

                    100% {
                        opacity: 1;
                        scale: 1;
                    }
                }
            </style>

            <button class="trigger" onclick="this.getRootNode().host.showModal(event)">${this.dataset.label}</button>

            <dialog autofocus>
                <slot></slot>
                <button class="close" title="Close Dialog" onclick="this.getRootNode().host.close(event)"></button>
            </dialog>
        `
    }
})